import authAction from "../redux/auth/actions";
import axios from "axios";
import { getXAPIKey } from "./utility";
import { store } from "../redux/store";

/** Replace `companyId` 0 / "0" with the logged-in company id (nested objects). */
function coerceCompanyIdInPayload(payload, companyId) {
  const cid = Number(companyId);
  if (!Number.isFinite(cid) || cid <= 0 || payload == null) {
    return payload;
  }
  if (Array.isArray(payload)) {
    return payload.map((item) => coerceCompanyIdInPayload(item, cid));
  }
  if (typeof payload !== "object") {
    return payload;
  }
  const out = { ...payload };
  Object.keys(out).forEach((key) => {
    const val = out[key];
    if (key === "companyId" && (val === 0 || val === "0")) {
      out[key] = cid;
    } else if (val !== null && typeof val === "object") {
      out[key] = coerceCompanyIdInPayload(val, cid);
    }
  });
  return out;
}

const METHOD = {
  GET: "get",
  POST: "post",
  PUT: "put",
  DELETE: "delete",
  PATCH: "patch",
};

const BASEURL = process.env.REACT_APP_API_URL;

// CHECK BELOW FOR SAMPLE DATA TO BE PASSED
class Api {
  isLoggedIn = false;
  userData = {};

  constructor() {
    this.baseURL = BASEURL;
  }

  getAuthenticationInfo() {
    if (localStorage.getItem("isLoggedIn")) {
      this.isLoggedIn = true;
      this.userData = store.getState().Auth;
    }
  }

  // URL FOR API
  // REFER SAMPLE JSON AT BOTTOM FOR DATA VALUES
  get(url, data) {
    return new Promise((resolve, reject) => {
      this.api(METHOD.GET, url, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
        });
    });
  }

  post(url, data) {
    return new Promise((resolve, reject) => {
      this.api(METHOD.POST, url, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
        });
    });
  }

  put(url, data) {
    return new Promise((resolve, reject) => {
      this.api(METHOD.PUT, url, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
        });
    });
  }

  patch(url, data) {
    return new Promise((resolve, reject) => {
      this.api(METHOD.PATCH, url, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
        });
    });
  }

  delete(url, data) {
    return new Promise((resolve, reject) => {
      this.api(METHOD.DELETE, url, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
        });
    });
  }

  api(method, url, data) {
    return new Promise((resolve, reject) => {
      let axiosConfig = {};
      axiosConfig.method = method;
      axiosConfig.url = this.baseURL + url;
      axiosConfig.headers = this.setHeaders(data);
      if (data) {
        if (data.params) axiosConfig.params = data.params;
        if (data.signal) axiosConfig.signal = data.signal;

        if (data.data) {
          if (data.isMultipart && data.data instanceof FormData) {
            axiosConfig.data = data.data; // Use FormData directly for multipart
          } else {
            let payload = data.data;
            const authCompanyId = Number(
              store.getState().Auth && store.getState().Auth.company
                ? store.getState().Auth.company.id
                : NaN
            );
            if (
              Number.isFinite(authCompanyId) &&
              authCompanyId > 0 &&
              typeof payload === "object" &&
              payload !== null
            ) {
              payload = coerceCompanyIdInPayload(payload, authCompanyId);
            }
            axiosConfig.data = JSON.stringify(payload);
          }
        }
      }
      axios(axiosConfig)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          if (error.response !== undefined) {
            if (error.response.status === 401) {
              let data = error.response.data;
              if (data.status === 2) {
                store.dispatch(
                  authAction.pendingPayment({
                    showPage: true,
                    userId: data.data.userId,
                    hasCard: data.data.isCardAdded,
                  })
                );
              } else {
                store.dispatch(authAction.logout());
              }
            }
          }
          if (error.response && error.response.data) {
            resolve(error.response.data);
          } else {
            resolve(error);
          }

          //DEFAULT ERROR HANDLING
        });
    });
  }

  setHeaders(data) {
    let headers = {};
    headers["accept-language"] = "en";
    headers["x-api-key"] = getXAPIKey();

    if (data) {
      if (data.isMultipart) {
        // Do NOT set Content-Type for multipart/form-data! Let the browser set it with the boundary.
      } else {
        headers["Content-Type"] = "application/json";
      }

      if (data.headers)
        for (var key in data.headers)
          if (data.headers.hasOwnProperty(key))
            headers[key] = data.headers[key];
    }

    if (
      store.getState().Auth.accessToken !== "" &&
      store.getState().Auth.accessToken !== "eyJhbGciOiJIUzUxMiJ9"
    ) {
      headers["access-token"] = store.getState().Auth.accessToken;
    }
    return headers;
  }
}

export default Api;
